import api from 'Application/api/api';

const removeAttachedDocument = (signal, invoiceId) =>
	api.delete(`/invoices/remove-attached-document/${invoiceId}`, {
		signal,
	});

export default removeAttachedDocument;
